<template>
  <div class="view" id="tokens">
    <div class="view__bar">
      <div class="container">
        <div class="row">
          <div class="rowColumn">
            <sapp-back />
            <span class="bar__title">Tokens</span>
          </div>
        </div>
      </div>
    </div>
    <div class="view__content">
      <div class="container">
        <h1>This is the Tokens page</h1>
        <!-- <tokens-form></tokens-form> -->
      </div>
    </div>
  </div>
</template>

<script>
// var lcTokensForm = {
//   template: "#temp-tokens"
// };
export default {
  name: "tokens",
  components: {
    // "tokens-form": lcTokensForm
  }
};
</script>
